import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Row } from 'antd';
import { useStyle } from './style';

var Loading = function Loading(props) {
  var style = props.style,
      prefix = props.prefix;

  var _useStyle = useStyle(prefix || 'ant-pro-card'),
      wrapSSR = _useStyle.wrapSSR;

  return wrapSSR(_jsxs("div", {
    className: "".concat(prefix, "-loading-content"),
    style: style,
    children: [_jsx(Row, {
      gutter: 8,
      children: _jsx(Col, {
        span: 22,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })
    }), _jsxs(Row, {
      gutter: 8,
      children: [_jsx(Col, {
        span: 8,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), _jsx(Col, {
        span: 15,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    }), _jsxs(Row, {
      gutter: 8,
      children: [_jsx(Col, {
        span: 6,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), _jsx(Col, {
        span: 18,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    }), _jsxs(Row, {
      gutter: 8,
      children: [_jsx(Col, {
        span: 13,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), _jsx(Col, {
        span: 9,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    }), _jsxs(Row, {
      gutter: 8,
      children: [_jsx(Col, {
        span: 4,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), _jsx(Col, {
        span: 3,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), _jsx(Col, {
        span: 16,
        children: _jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    })]
  }));
};

export default Loading;